module.exports = __webpack_public_path__ + "media/src/images/icons/folder_new-088842c817f1a3e7190f3538f605ffea.svg";